import { Currency, PaymentTerm, Unit } from '../common';
import { AgreementItem, Product, ShippingSource } from '../order-management';
import { CounterOffer } from './counter-offer';
import { OrderItemProfile } from './order-item-profile';
import { Lot } from '../jobsite-std-lot/lot';
import { OrderItemService } from './order-item-service';

export interface OrderItem {
  agreementItem: AgreementItem;
  currency: Currency;
  counterOffers?: CounterOffer[];
  grossPrice: number;
  itemSeqNum: number;
  orderItemId: number;
  orderItemProfile: OrderItemProfile;
  paymentTerm: PaymentTerm;
  product: Product;
  programmedDateTime: string;
  purchaseOrder: string;
  quantity: number;
  requestedDateTime: string;
  shippingSource?: ShippingSource;
  taxAmount: number;
  totalPrice: number;
  uom: Unit;
  lot: Lot;
  services?: OrderItemService[];
  timeWindowCode?: string;
  timeWindowDesc?: string;
  timeWindowId?: number;
}
